import { useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n';
import { useAddresses, addressLine, addressTitle } from '../hooks/useAddresses';
import { useLocationPicker } from '../hooks/useLocationPicker';
import { LocationSheet } from './LocationSheet';

/** Wires the location sheet to its hooks (GPS, saved addresses, live towns). */
export function LocationChooser({ signedIn, onClose }: { signedIn: boolean; onClose: () => void }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const names = { home: t('address.home'), work: t('address.work'), other: t('address.other') };
  const list = useAddresses(signedIn, { deleted: t('address.deleted') });
  const picker = useLocationPicker({
    labels: {
      current: t('location.current'),
      townCentre: (town) => t('location.townCentre', { town }),
      ...names,
    },
    onChosen: onClose,
  });
  return (
    <LocationSheet
      title={t('location.choose')}
      labels={{
        useCurrent: t('location.useCurrent'),
        locating: t('location.locating'),
        denied: t('location.denied'),
        unavailable: t('location.unavailable'),
        saved: t('location.saved'),
        add: t('location.addAddress'),
        signInToSave: t('location.signInToSave'),
        towns: t('location.towns'),
        notServed: t('location.notServed'),
        default: t('address.default'),
      }}
      gps={picker.gps}
      onUseCurrent={picker.useCurrent}
      addresses={list.addresses}
      addressTitle={(address) => addressTitle(address, names)}
      addressLine={addressLine}
      onChooseAddress={picker.chooseAddress}
      signedIn={signedIn}
      onAddAddress={() => {
        onClose();
        navigate('/address/new');
      }}
      onSignIn={() => {
        onClose();
        navigate('/sign-in');
      }}
      towns={picker.towns}
      onChooseTown={picker.chooseTown}
      onClose={onClose}
    />
  );
}
